import { render, staticRenderFns } from "./IP_TrendingPrintable.vue?vue&type=template&id=61481a8a&scoped=true&"
import script from "./IP_TrendingPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_TrendingPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_TrendingPrintable.vue?vue&type=style&index=0&id=61481a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61481a8a",
  null
  
)

export default component.exports